export class TaskFile {
    public name: string;
    public size: number;
    public type: string;
    public usage: string;
}
